/**
 * Temas usados para cada página
 */
export const themes = {
  inicio: {
    color: 'rgb(0,164,160)',
    colorBarra: '#2abda7',
    colorHover: 'rgba(0,164,160,.5)',
    search: {
      background: 'rgb(255,255,255)',
    },
  },
  presidente: {
    color: 'rgb(166,129,61)',
    colorBarra: '#2abda7',
    colorHover: 'rgba(166,129,61,.5)',
    search: {
      background: 'rgb(255,255,255)',
    },
  },
  camara: {
    color: 'rgb(180,86,174)',
    colorBarra: '#2abda7',
    colorHover: 'rgba(180,86,174,.5)',
    search: {
      background: 'rgb(255,255,255)',
    },
  },
  coalicion: {
    color: 'rgb(139,134,129)',
    colorBarra: '#2abda7',
    colorHover: 'rgba(139,134,129,.5)',
    search: {
      background: 'rgb(255,255,255)',
    },
  },
  citrep: {
    color: 'rgb(225,103,64)',
    colorBarra: '#2abda7',
    colorHover: 'rgba(225,103,64,.5)',
    search: {
      background: 'rgb(255,255,255)',
    },
  },
  pacto: {
    color: 'rgb(0,157,165)',
    colorBarra: '#2abda7',
    colorHover: 'rgba(0,157,165,.5)',
    search: {
      background: 'rgb(255,255,255)',
    },
  },
  equipo: {
    color: 'rgb(180,86,174)',
    colorBarra: '#2abda7',
    colorHover: 'rgba(180,86,174,.5)',
    search: {
      background: 'rgb(255,255,255)',
    },
  },
  estadisticas: {
    color: 'rgb(242,103,34)',
    colorBarra: '#2abda7',
    colorHover: 'rgba(242,103,34,.5)',
    search: {
      background: 'rgb(255,255,255)',
    },
  },
  mesasInformadas: {
    color: 'rgb(28 65 131)',
    colorBarra: '#1C4183',
    colorHover: 'rgba(28 65 131,.5)',
    search: {
      background: 'rgb(255,255,255)',
    },
  },
  votos: {
    color: 'rgb(91, 194, 231)',
    colorBarra: '#5BC2E7',
    colorHover: 'rgba(243 173 28,.5)',
    search: {
      background: 'rgb(255,255,255)',
    },
  },
  sectores: {
    color: 'rgb(215, 27, 38)',
    colorBarra: '#D71B26',
    colorHover: 'rgba(215, 27, 38, 1)',
    search: {
      background: 'rgb(255,255,255)',
    },
  },
  color: {
    sinInfo: "hsl(228, 2%, 85%)",
    noPresentado: "rgba(0,0,0,0.05)",
    sinAsignar: "#d8d8da",
    circPaz:"#A2789C",
    mapBorder: "rgba(0, 0, 0, 0.3)",
    mapBorderHover: "rgba(0, 0, 0, 0.5)",
    primary: 'rgb(28 65 131)',
    empate: '#646464'
  },
};
